import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { PartnersListControllerModule } from './controllers/PartnersListController';

export const PartnersListView = angular
  .module('acme.view.application.partners.list', [
    uiRouter,
    'ui.bootstrap',
    PartnersListControllerModule,
    'acme.view.application.partners.list.categories',
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.partners.list',
      url: '/list',
      abstract: true,
      views: {
        'subview-main': {
          templateUrl: 'views/application/views/partners/list/list.tpl.html',
        },
      },
      data: {
        pageTitle: 'Organizations',
        enablePreferences: true,
      },
    });

    $stateProvider.state({
      name: 'application.partners.list.default',
      url: '',
      views: {
        'subview-main': {
          controller: 'PartnersListController',
          templateUrl: 'views/application/views/partners/list/listPartners.tpl.html',
        },
      },
    });
  }).name;
